

const reducer = (state, action) =>
  Object.entries(action).reduce(
    (state, [category, updates]) => {
      let stateBuilder = { ...state }
      if (category !== 'type') {
        stateBuilder[category] = { ...state[category], ...updates }
      }
      return stateBuilder
    }, state);

export default reducer;


// WEBPACK FOOTER //
// ./src/reducer.js